import ModelStore from 'stores/model/ModelStore'

import createError from 'utils/createError'

const getRecordId = (modelId: string, recordValue: any): string => {
  if (recordValue === null || recordValue === undefined) {
    throw createError('getRecordId', 'Invalid recordValue', {
      modelId,
      recordValue,
    })
  }

  const model = ModelStore.get(modelId)
  if (!model) {
    throw createError('getRecordId', 'Invalid modelId', {
      modelId,
    })
  }

  let recordId = `${modelId}::`

  // Use all fields that uniquely identify this model
  recordId += model.uniqueIdentifiers
    .map(f => {
      // Unique fields are allowed to be `null` or `undefined`, as long as they're unique
      if (recordValue[f.name] === null) {
        return 'null'
      }

      if (recordValue[f.name] === undefined) {
        return 'undefined'
      }

      return recordValue[f.name]
    })
    .join(',')

  return recordId
}

export default getRecordId
